import React, { FC } from 'react';
import { css } from '@emotion/react';
import { Dialog, DialogProps, styled } from '@mui/material';


const modalStyles = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',

  '& .MuiDialog-paper': {
    width: 'calc(100% - 24px)',
    maxWidth: '450px',
    margin: '12px',
    backgroundColor: 'var(--surface)',
    padding: '24px 0',
    borderRadius: '16px',

    '& .MuiDialogTitle-root': {
      padding: '0',
      margin: '0',
      fontWeight: '900',
      fontSize: '24px',
      lineHeight: '1',
      color: 'inherit',
    },
    '& .MuiDialogContent-root': {
      padding: '0',
      paddingTop: '16px',
      color: 'inherit',

      '& .MuiDialogContentText-root': {
        fontFamily: 'CircularStd',
        color: 'var(--text-2)',
        fontWeight: '450',
        fontSize: '16px',
        lineHeight: '22.4px',
      },
    },
    '& .MuiDialogActions-root': {
      borderTop: '1px solid var(--border)',
      padding: '16px 24px 0',
    },
  },

  '@media (min-width: 600px)': {
    '& .MuiDialog-paper': {
      margin: '32px',
      maxWidth: 'calc(100% - 64px)',
    },
  },
});

const StyledDialog = styled( Dialog )( modalStyles );
export const TDCDialog:FC<DialogProps> = ( props ) => {
  const a = 1;
  return (
    <StyledDialog { ...props } />
  );
};

export const ModalTopWrapper = styled( 'div' )({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 24px 24px',
});

export const ModalMainWrapper = styled( 'div' )({
  display: 'block',
  padding: '0',
  margin: '0',
});

export const ModalCloseWrapper = styled( 'div' )({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'end',
  padding: '0 0 8px 8px',
  margin: '0',
  width: '40px',
  minWidth: '40px',
  maxWidth: '40px',

  '& svg': {
    width: '24px',
    height: '24px',
  }
})